import React from 'react';
import { Container, Box, Typography, Link, Divider, List, ListItem, ListItemText } from '@mui/material';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import Footer from '../../components/Footer/footer';

const SectionHeading = ({ children }) => (
  <Typography variant="h5" component="h2" sx={{ mt: 6, mb: 2, fontWeight: 700 }}>
    {children}
  </Typography>
);

export default function LegalDisclosuresPage() {
  return (
    <>
      <LandingPageNav />
      <Container maxWidth="md" sx={{ pt: { xs: 10, md: 12 }, pb: { xs: 6, md: 8 } }}>
        <Box>
          <Typography variant="h3" component="h1" sx={{ fontWeight: 800, mb: 3 }}>
            Jet HomeLoans, LLC Legal Disclosures and License Information
          </Typography>

          <Typography variant="body1" sx={{ mb: 3 }}>
            It is the policy of Jet HomeLoans, LLC (Jet) to comply with the Equal Credit Opportunity Act and the Fair Housing Act. In addition, it is Jet policy to comply with state laws that provide greater protection. Jet is an Equal Housing Lender, and does not engage in business practices that discriminate against any applicant on the basis of race; color; religion; creed; national origin; ancestry; sex; marital status; familial status (number and age of children); sexual orientation; age (provided that the applicant has the capacity to enter into a binding agreement); medical history; disability; physical condition; military status; because the applicant has in good faith exercised any right under the Consumer Credit Protection Act or Servicemembers Civil Relief Act (SCRA); that all or part of a consumer’s income derives from a public assistance program; or any other basis prohibited by law. The federal agency that administers our compliance with these federal laws is the Federal Trade Commission, Equal Credit Opportunity, Washington, DC, 20580.
          </Typography>

          <SectionHeading>State Disclosure Requirements</SectionHeading>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Jet HomeLoans, LLC is a licensed mortgage lender in the following states:
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 700 }}>Alabama</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            1660135. Consumer Credit License #1660135.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 700 }}>Arizona</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            BK-20006824. Mortgage Banker License BK-20006824. 130 E Congress St, Ste 200, Tucson AZ 85701.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 700 }}>California</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            41DBO-185182. Licensed by the Department of Financial Protection and Innovation under the California Residential Mortgage Lending Act, RMLA #41DBO-185182. <Link href="/ccpa" underline="hover">View our CCPP policy</Link>.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 700 }}>Colorado</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Licensed under company NMLS #1660135.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 700 }}>District of Columbia</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            MLB1660135. Mortgage Dual Authority; Licensed under company NMLS 1660135.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 700 }}>Florida</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            MLD1926. Mortgage Lender Licenses MLD1926.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 700 }}>Georgia</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Mortgage Lender Licenses 58935.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 700 }}>Idaho</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            MBL-2081660135. Mortgage Broker / Lender License MBL-2081660135.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 700 }}>Maryland</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            1660135. Mortgage Lender License #1660135.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 700 }}>North Carolina</Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            L-193001. Mortgage Lender License #L-193001.
          </Typography>
          <List sx={{ mb: 2 }}>
            <ListItem disableGutters>
              <ListItemText primary="NMLS 1718534 – Jacksonville FL" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="NMLS 1974004 – Winter Park, FL" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="NMLS 2131696 – Charlotte, NC" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="NMLS 2136057 – Fayetteville NC" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="NMLS 1974411 – Bluffton SC" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="NMLS 2730240 – Greenville SC" />
            </ListItem>
          </List>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 700 }}>South Carolina</Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            MLS-1660135. South Carolina – BFI Mortgage Lender/Servicer License #MLS-1660135.
          </Typography>
          <List sx={{ mb: 2 }}>
            <ListItem disableGutters>
              <ListItemText primary="NMLS 1718534 – 13901 Sutton Park Dr S, Ste 101, Jacksonville FL 32224" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="NMLS 1974004 – 2707 W Fairbanks Ave, Ste 200, Winter Park, FL 32789" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="NMLS 2131696 – 301 McCullough Dr, Ste 400, Charlotte NC 28262" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="NMLS 2136057 – 242 Hay St, Fayetteville, NC 28301" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="NMLS 1974411 – 12 Johnston Way, Ste A&B, Bluffton SC 29910" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="NMLS 2579911 – 576 Savannah Hwy, Charleston SC 29407" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="NMLS 2730240 – 355 S. Main St, 1st Floor, Office 2298, Greenville SC 29601" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="NMLS 2594400 – 3401 Mallory Ln, Ste 100, Office 262, Franklin TN 37067" />
            </ListItem>
          </List>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 700 }}>Tennessee</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            1660135. Mortgage License #1660135.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 700 }}>Texas</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Licensed under company NMLS #1660135. Mortgage Banker Registration; NMLS #1660135.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Figure: 7 TAC §81.200(c) Consumers wishing to file a complaint against a mortgage banker or a licensed mortgage banker residential mortgage loan originator should complete and send a complaint form to the Texas department of savings and mortgage lending, 2601 North Lamar, Suite 201, Austin, Texas 78705. Complaint forms and instructions may be obtained from the department’s website at <Link href="https://www.sml.texas.gov" target="_blank" rel="noopener">www.sml.texas.gov</Link>. A toll-free consumer hotline is available at 1-877-276-5550. The department maintains a recovery fund to make payments of certain actual out of pocket damages sustained by borrowers caused by acts of licensed mortgage banker residential mortgage loan originators. A written application for reimbursement from the recovery fund must be filed with and investigated by the department prior to the payment of a claim. For more information about the recovery fund, please consult the department’s website at <Link href="https://www.sml.texas.gov" target="_blank" rel="noopener">www.sml.texas.gov</Link>.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 700 }}>Virginia</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            MC-7141. Mortgage Broker License MC-7141. NC-7141. Mortgage Lender License MC-7141.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 700 }}>Washington</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            CL-1660135. Consumer Loan Company License #CL-1660135.
          </Typography>

          <Typography variant="body1" sx={{ mb: 3 }}>
            Jet HomeLoans, LLC Nationwide Mortgage Licensing System Number 1660135 Toll Free Number: (833) 270-7191
          </Typography>

          <SectionHeading>Jet HomeLoans, LLC Affiliated Businesses</SectionHeading>
          <List sx={{ mb: 2 }}>
            <ListItem disableGutters>
              <ListItemText primary="Dream Finders Homes, LLC" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="DF Title, LLC d/b/a Golden Dog Title" />
            </ListItem>
          </List>

          <SectionHeading>Pre-Approval Disclosure</SectionHeading>
          <Typography variant="body1" sx={{ mb: 3 }}>
            *“Pre-Approval” means an automated underwriting system approval (conditional approval) based upon credit information supplied by applicant and subject to Jet HomeLoans, LLC’s review of loan documents. Not all applicants will be approved.
          </Typography>

          <SectionHeading>Information regarding risks of reverse mortgages:</SectionHeading>
          <List>
            <ListItem disableGutters>
              <ListItemText primary="A reverse mortgage is a loan that must be repaid" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="Circumstances under which payments or access to a line of credit may end or a consumer would be required to repay a reverse mortgage during the consumer’s life (e.g., the borrower sells the home)" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="Foreclosure may occur if the consumer (1) lives somewhere other than the home longer than allowed by the loan agreement; or (2) does not pay property taxes or insurance premiums" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="Consumers must make payments for taxes and insurance during the term of the reverse mortgage" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="Reverse mortgage costs may vary and less expensive options may be available" />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="A reverse mortgage may affect eligibility for some government programs. Specifically, SSI and Medicaid may be affected." />
            </ListItem>
            <ListItem disableGutters>
              <ListItemText primary="In order to retain the home when the reverse mortgage becomes due that (1) the consumer or the consumer’s heirs or estate must pay the entire loan balance and (2) the balance may be greater than the value of the consumer’s home." />
            </ListItem>
          </List>

          <Divider sx={{ my: 5 }} />
          <Typography variant="body2" color="text.secondary">
            {/* Optionally include a last updated date here if applicable. */}
          </Typography>
        </Box>
      </Container>
      <Footer />
    </>
  );
}
